import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "core-js/modules/es6.regexp.to-string";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import * as constants from "./constants";
import HttpClient from "../http/index";
import { isJSON } from "@/utils/lodash";
import { sendMapEvent } from "@/utils/analytics";
import { clientError, getLang } from "@/api/utils/apiHelper";
import { toString } from "lodash";

var faceClientErrorEvent = function faceClientErrorEvent(key, result) {
  try {
    if (result.data && typeof result.data === "string" && result.data.includes("false")) {
      if (isJSON(result.data)) {
        var error = JSON.parse(result.data);
        sendMapEvent("face_" + key, {
          error_code: error.code ? toString(error.code) : "1001",
          error_message: error.message ? error.message : "null"
        });
      } else {
        sendMapEvent("face_" + key, {
          error_code: "1002",
          error_message: result.data
        });
      }
    } else {
      sendMapEvent("face_" + key, {
        error_code: "",
        error_message: toString(result)
      });
    }
  } catch (error) {}
};

var FaceClient =
/*#__PURE__*/
function () {
  function FaceClient() {
    _classCallCheck(this, FaceClient);
  }

  _createClass(FaceClient, [{
    key: "CommonRequestFactory",
    value: function CommonRequestFactory(method, path) {
      var req = {};
      req.method = method;
      req.baseUrl = constants.BASE_URL;
      req.path = path;
      var deviceInfo = window.device;
      var launchTime = new Date().getTime() / 1000;
      req.headers = {};
      req.headers["User-Agent"] = constants.UA;
      req.headers['x-faceapp-applaunched'] = launchTime.toString();
      req.headers['x-faceapp-ios'] = constants.systemVersion;
      req.headers['x-faceapp-model'] = constants.deviceModel;
      req.headers['x-faceapp-deviceid'] = deviceInfo.deviceId;
      req.headers['x-faceapp-applaunched-version'] = constants.appVersion;
      req.headers['Accept-Language'] = this.language;
      return req;
    }
    /**
     * 明星图库信息
     */

  }, {
    key: "req_celebrities",
    value: function req_celebrities() {
      var _this = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          var req, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  req = _this.CommonRequestFactory("GET", constants.FACE_CELE_PATH); // req.query.client_lang = this.language;

                  _context.next = 4;
                  return HttpClient.get(constants.BASE_URL + constants.FACE_CELE_PATH, req);

                case 4:
                  res = _context.sent;
                  faceClientErrorEvent("req_celebrities", res); //打点

                  if (res.status === 200 && res.data) {
                    resolve(JSON.parse(res.data));
                  }

                  resolve(res);
                  _context.next = 14;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](0);
                  clientError("req_celebrities", _context.t0);
                  reject(_context.t0);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 10]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * 明星图库照片
     */

  }, {
    key: "req_photos",
    value: function req_photos(query, pageNo) {
      var _this2 = this;

      return new _Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var req, pageSize, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  req = _this2.CommonRequestFactory("GET", constants.FACE_PHOTO_PATH);
                  pageSize = 18;
                  req.params = {};
                  req.params.limit = pageSize.toString();
                  req.params.offset = (pageNo * pageSize).toString();
                  req.params.q = query;
                  _context2.next = 9;
                  return HttpClient.get(constants.BASE_URL + constants.FACE_PHOTO_PATH, req);

                case 9:
                  res = _context2.sent;
                  faceClientErrorEvent("req_photos", res); //打点

                  if (res && res.data && res.status === 200) {
                    resolve(JSON.parse(res.data));
                  }

                  _context2.next = 18;
                  break;

                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](0);
                  clientError("req_photos", _context2.t0);
                  reject(_context2.t0);

                case 18:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 14]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "language",
    get: function get() {
      return getLang();
    }
  }]);

  return FaceClient;
}();

export default new FaceClient();